module.exports = __webpack_public_path__ + "img/sao-tome-and-principe.4653aefd.svg";